function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M3 60.8102C3 29.3299 28.5198 3.81017 60 3.81017H61.3157C92.7959 3.81017 118.316 29.3299 118.316 60.8102V60.8102H3V60.8102Z",
  fill: "transparent"
}), React.createElement("path", {
  d: "M120.292 60.8102C120.292 48.1394 116.305 35.7939 108.901 25.5431L106.006 27.6591C112.965 37.2949 116.713 48.8997 116.713 60.8102H120.292Z",
  fill: "#4293F6",
  stroke: "white"
}), React.createElement("path", {
  d: "M108.901 25.5431C101.497 15.2922 91.0573 7.66227 79.0778 3.74678L77.9719 7.17059C89.2326 10.8511 99.046 18.0233 106.006 27.6591L108.901 25.5431Z",
  fill: "#91BDF3",
  stroke: "white"
}), React.createElement("path", {
  d: "M79.0778 3.74678C67.0982 -0.168697 54.194 -0.168697 42.2144 3.74678L43.3203 7.17059C54.5811 3.49003 66.7111 3.49003 77.9719 7.17059L79.0778 3.74678Z",
  fill: "#D2D4DB",
  stroke: "white"
}), React.createElement("path", {
  d: "M42.2104 3.7481C30.2311 7.66444 19.7919 15.2951 12.3889 25.5465L15.2843 27.6623C22.2432 18.026 32.056 10.8532 43.3165 7.17182L42.2104 3.7481Z",
  fill: "#A1E481",
  stroke: "white"
}), React.createElement("path", {
  d: "M12.3914 25.543C4.98764 35.7939 0.999998 48.1394 1 60.8102L4.57877 60.8102C4.57876 48.8997 8.32714 37.2949 15.2867 27.6591L12.3914 25.543Z",
  fill: "#46D24B",
  stroke: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 60.6579,
  y1: 3.81017,
  x2: 60.6579,
  y2: 60.8102,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.677083,
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 121,
  height: 60,
  fill: "white"
})));

var SvgSpeedometer = function SvgSpeedometer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 121,
    height: 60,
    viewBox: "0 0 121 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpeedometer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speedometer.d9692755.svg";
export { ForwardRef as ReactComponent };